module.exports = __webpack_public_path__ + "static/media/Madfit-1.669e4237.jpg";